import { attr, hasMany } from '@ember-data/model';
import { alias } from '@ember/object/computed';
import { computed } from '@ember/object';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
export const CompositionType = NumericEnum.create(['INVALID_COMPOSITION_TYPE', 'FIXED_COMPOSITION', 'STOCK_CONVERSION']);
export default ItemsV3Base.extend({
  quantity: attr('number'),
  quantityDenominator: attr('number', {
    defaultValue: 1
  }),
  components: hasMany('component', {
    async: false
  }),
  // Note: `itemVariation` is actually a 1:1 relationship, but the attribute representing the relationship
  // is on the variation, so this side is a "hasMany", although in practice there will only ever be 1 variation
  // per composition.
  itemVariations: hasMany('item-variation', {
    async: false
  }),
  itemVariation: alias('itemVariations.firstObject'),
  compositionType: attr('enum', {
    enumClass: CompositionType
  }),
  componentsAreLoaded: computed('components', function () {
    return this.hasMany('components').value() !== null;
  }),
  isDirty: computed('components.@each.isDirty', 'hasDirtyFields', 'componentsAreLoaded', function () {
    if (this.componentsAreLoaded && (this.components || []).any(o => o && o.isDirty)) {
      return true;
    }
    return this._super();
  }),
  rollbackRelationships() {
    if (this.componentsAreLoaded) {
      (this.components || []).filter(o => !o.isNew).forEach(o => o.rollbackRelationships());
    }
    this._super();
  },
  rollbackAttributes() {
    if (this.componentsAreLoaded) {
      (this.components || []).filter(o => !o.isNew).forEach(o => o.rollbackAttributes());
    }
    this._super();
  }
}).reopenClass({
  catalogType() {
    return 'COMPOSITION';
  },
  _modelNameForMigration: 'composition'
});